import Row from 'Components/Base/Row'
import Template1 from 'Pages/CTLChallenges/Components/Templates/Template1'
import React, { useEffect, useState } from 'react'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import { Paragraph, SectionInfo } from 'types/Challenge'

interface Props {
  step: number
  setInfoPage: (infoPage: boolean) => void
}
export default function WeightLossStep4({ step, setInfoPage }: Props) {
  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()
  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()
  const [isMobile, setIsMobile] = useState<boolean>()

  useEffect(() => {
    window.scrollTo(0, 0)
    setInfoPage(true)
    setSectionInfo(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      ),
    )
    setStepParagraphs(
      data.pageInfoBySection.sectionInfo.find(
        (sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]),
      )?.paragraphs,
    )
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1200) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    })

    if (window.innerWidth < 1200) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }, [step])

  return (
    <Template1
      isMobile={isMobile}
      textSection={
        <>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <p style={{ fontFamily: 'Raleway', fontSize: 20 }}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 9)?.paragraph ?? ''}</p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <p style={{ fontFamily: 'Raleway', fontSize: 20, fontWeight: 'bold' }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 10)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 11)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 12)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 13)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 14)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 15)?.paragraph ?? ''}
            </p>
          </Row>
          <Row styles={{ margin: isMobile ? '20px 0px' : '5px 0px' }}>
            <li></li>
            <p style={{ marginRight: 5, fontFamily: 'Raleway', fontSize: 20 }}>
              {stepParagraphs?.find((paragraph) => paragraph.paragraphId === 16)?.paragraph ?? ''}
            </p>
          </Row>
        </>
      }
      imgSrc={sectionInfo?.images.find((image) => image.imageId === 4)?.url ?? ''}
    />
  )
}
